import React from 'react';
import styled from 'styled-components';
const Badge = styled.span`
    && {
        display:inline-flex; align-items:center; justify-content:center;
        box-sizing:border-box; flex:0 0 20px; width:20px; height:20px;
        padding:0; margin:0 0 0 8px;
        border-radius:50%; background:#ec1b23; color:#fff;
        font-size:11px; font-weight:700; line-height:1; text-indent:0;
    }
`;
export default function DeviceAlertBadge({visible}) {
    return visible ? <Badge aria-label="확인하지 않은 기기 이상 알림">1</Badge> : null;
}
